import React from 'react';
import PropTypes from 'prop-types';
import { PayerSelectDrawer } from './PayerSelectDrawer';

export const Widget = props => {
  return <PayerSelectDrawer {...props} />;
};

Widget.displayName = 'utility/PayerSelectDrawer';

Widget.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    payerId: PropTypes.string,
    application: PropTypes.string,
    isPayerOpen: PropTypes.bool,
    togglePayer: PropTypes.func,
  }),
  events: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {
    title: 'Payer Select Drawer',
  },
  events: null,
};
